@if (data) {
    <mat-dialog-content class="d-flex flex-col">
        <div class="flex-row flex-space-between">
            <div>
                <mat-card-header class="p-0">
                    @if (data.title) {
                        <mat-card-title>
                            <h3 class="m-0" mat-dialog-title>{{ data.title }}</h3>
                        </mat-card-title>
                    }
                </mat-card-header>
            </div>
            <div class="float-end">
                <button (click)="this.dialogRef.close();" aria-label="Close window" class="mat-dialog-close "
                        mat-dialog-close
                        mat-icon-button
                        matTooltip="Close Window">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </div>
        <mat-card-content>
            @if ("content_rendered" in data && (data.content_rendered || data.content)) {
                <div [innerHTML]="data.content_rendered || data.content"
                     class="content"></div>
            }
            @if ("isVideo" in data && data.isVideo) {
                <div class="text-center w-100 d-flex justify-content-center">
                    @if (data.attachment) {
                        <video (play)="recordVideoView()" class="videoControl" controls crossorigin="anonymous">
                            <source [src]="data.attachment">
                            @if (data.vtt_file) {
                                <track [src]="data.vtt_file"
                                       default
                                       kind="captions"
                                       label="English"
                                       srclang="en"/>
                            }
                            Your browser does not support the video tag.
                        </video>
                    }
                </div>
                @if (data.description) {
                    <p>
                        {{ data.description }}
                    </p>
                }
            }
        </mat-card-content>
    </mat-dialog-content>
}
@if ("isVideo" in data && !data.isVideo) {
    <mat-dialog-actions>
        @if (data.attachment) {
            <button (click)="link(data.attachment, false, data.title)"
                    (keyup.enter)="link(data.attachment, false, data.title)"
                    color="primary" mat-raised-button>Download
            </button>
        }
    </mat-dialog-actions>
}
